import styled from '@emotion/styled/macro';

import { Line } from '../../../../../styledComponents/UI/Line/Line';

export const DetailsLine = styled(Line)`
  margin: 1.5rem 0;
`;
